export default __webpack_public_path__ + "static/media/island.de3ee238.jfif";